// columns.js

const generalStaffSalaryColumns = [
  {
    title: "Salary",
    dataIndex: "salary",
    key: "salary",
  },
  {
    title: "Employee Name",
    dataIndex: "employeeName",
    key: "employeeName",
  },
  {
    title: "Employee Branch",
    dataIndex: "employeeBranch",
    key: "employeeBranch",
  },
  {
    title: "Branch Name",
    dataIndex: "branchName",
    key: "branchName",
  },
];

export default generalStaffSalaryColumns;
